import { InProgressTestCard } from "./InProgressTestCard";
import { AlertCircle } from "lucide-react";

interface InProgressTest {
  id: string;
  test_id: string;
  started_at: string;
  last_question_index: number;
  tests: {
    id: string;
    title: string;
    questions: { count: number }[];
    scheduled_end_time?: string;
  };
}

interface InProgressTestsSectionProps {
  tests: InProgressTest[];
}

export function InProgressTestsSection({ tests }: InProgressTestsSectionProps) {
  if (!tests || tests.length === 0) {
    return null;
  }

  // Filter out tests where scheduled_end_time has passed
  const availableTests = tests.filter((test) => {
    if (!test.tests.scheduled_end_time) {
      return true; // No scheduled end time means test is always available
    }
    const endTime = new Date(test.tests.scheduled_end_time);
    const now = new Date();
    return now <= endTime;
  });

  if (availableTests.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <AlertCircle className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-semibold text-foreground">Resume Your Tests</h2>
      </div>
      <p className="text-sm text-muted-foreground">
        You have {availableTests.length} test{availableTests.length > 1 ? 's' : ''} in progress. Pick up where you left off.
      </p>
      <div className="space-y-3">
        {availableTests.map((test) => (
          <InProgressTestCard
            key={test.id}
            testResponseId={test.id}
            testId={test.test_id}
            testTitle={test.tests.title}
            lastQuestionIndex={test.last_question_index}
            totalQuestions={test.tests.questions[0]?.count || 0}
            startedAt={test.started_at}
          />
        ))}
      </div>
    </div>
  );
}
